import { HttpParams, HttpResponse } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Tc } from '../../../core/_infrastructure/types/common';
import {
    ComunidadAutonomaItemResultsViewModel,
    FilterSearchingTcComunidadAutonomaViewModel,
    TcComunidadAutonomaViewModel,
    //TDeclaracionSuplementariaViewModel,
    //DeclaracionSuplementariaItemResultsViewModel,
} from './comunidadautonoma.types';
import { ResetFiltersService } from '../../../core/_infrastructure/classes/services/reset-filters.service';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';

@Injectable()
export class ComunidadAutonomaService extends ResetFiltersService {
    

    comunidadAutonomaEndpoint = this.baseUrl + 'api/mantenimiento/comunidadesautonomas/';

    private lastSearch?: FilterSearchingTcComunidadAutonomaViewModel;

    constructor(
        protected authService: AuthService,
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {
        super(authService);
    }

    private convertModelToHttpParms(payload: FilterSearchingTcComunidadAutonomaViewModel): HttpParams {
        let params = new HttpParams();
        let k: keyof FilterSearchingTcComunidadAutonomaViewModel;
        for (k in payload) {
            let v;
            v = payload[k] || '';
            params = params.append(k, v);
        }
        return params;
    }

    getComunidadesAutonomas(payload: FilterSearchingTcComunidadAutonomaViewModel): Observable<ComunidadAutonomaItemResultsViewModel> {
        this.lastSearch = payload; // Keep for future search
        const params = this.convertModelToHttpParms(payload);
        return this.getComunidadesAutonomasPagedByFilter(params);
    }

    getComunidadesAutonomasPagedByFilter(params: HttpParams): Observable<ComunidadAutonomaItemResultsViewModel> {
        return this.http.get<ComunidadAutonomaItemResultsViewModel>(this.comunidadAutonomaEndpoint + 'pagedbyfilter/', { params: params });
    }

    getComunidadAutonoma(id: number): Observable<TcComunidadAutonomaViewModel> {
        return this.http.get<TcComunidadAutonomaViewModel>(this. comunidadAutonomaEndpoint + id);
    }

    export(model: FilterSearchingTcComunidadAutonomaViewModel): Observable<HttpResponse<Blob>> {
        return this.http
            .post(this.baseUrl + 'api/mantenimiento/comunidadesautonomas/postExportExcelByFilter', model, { observe: 'response', responseType: 'blob' })
            .pipe();
    }


    saveComunidadAutonoma(comunidadAutonoma: TcComunidadAutonomaViewModel): Observable<any> {       
        return this.editComunidadAutonoma(comunidadAutonoma);   
    }

    editComunidadAutonoma(model: TcComunidadAutonomaViewModel): Observable<any> {
        return this.http.put<TcComunidadAutonomaViewModel>(this.comunidadAutonomaEndpoint, model); 
    }

    getLastSearch(): FilterSearchingTcComunidadAutonomaViewModel | undefined {
        return this.lastSearch;
    }

    clearLastSearch(): void {
        this.lastSearch = undefined;
    }

    resetFilter() {
        this.lastSearch = undefined;
    }
}
